import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Check } from 'react-feather';
import WritingSample from '../Modals/WritingSample';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUploadDisplay from '../../components/FileUploadDisplay';

const UploadWritingSample = ({ onFileSelect, initialFile }) => {
    const [currentFile, setCurrentFile] = useState(null);
    const [showWritingProposal, setShowWritingProposal] = useState(false);    

    // Load initial file when component mounts or initialFile changes
    useEffect(() => {
        if (initialFile) {
            // If initialFile is a File object, use it directly
            if (initialFile instanceof File) {
                setCurrentFile(initialFile);
            }
            // If initialFile is a string (S3 URL), set it as current file
            else if (typeof initialFile === 'string') {
                setCurrentFile(initialFile);
            }
            // If initialFile is an object with file data
            else if (initialFile && typeof initialFile === 'object') {
                if (initialFile.url) {
                    setCurrentFile(initialFile.url);
                } else if (initialFile.data) {
                    const file = new File(
                        [initialFile.data],
                        initialFile.name || 'writing_sample.pdf',
                        { type: 'application/pdf' }
                    );
                    setCurrentFile(file);
                }
            }
        } else {
            setCurrentFile(null);
        }
    }, [initialFile]);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        accept: { 'application/pdf': [] },
        maxFiles: 1,
        maxSize: 5 * 1024 * 1024, // 5MB limit
        onDrop: (acceptedFiles, rejectedFiles) => {
            if (acceptedFiles.length > 0) {
                const newFile = acceptedFiles[0];
                setCurrentFile(newFile);
                onFileSelect(newFile);
                toast.success('File selected successfully');
            }

            // Handle rejected files
            if (rejectedFiles.length > 0) {
                const rejectedFile = rejectedFiles[0];
                if (rejectedFile.errors.some(error => error.code === 'file-too-large')) {
                    toast.error('File size must be less than 5MB');
                } else if (rejectedFile.errors.some(error => error.code === 'file-invalid-type')) {
                    toast.error('Only PDF files less than 5MB are allowed');
                } else {
                    toast.error('File upload failed. Please try again.');
                }
            }
        }
    });

    const handleRemoveFile = () => {
        setCurrentFile(null);
        onFileSelect(null);
        toast.info('File removed. You can upload a new file.');
    };

    return (
        <>
            <div className="dropzone">
                 {/* <ToastContainer position="bottom-left" autoClose={3000} /> */}
                <div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
                    <input {...getInputProps()} />
                    <div className="dropzone-inner-wrapper">
                        {isDragAccept && (
                            <div>
                                <div className="d-100 btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white">
                                    <Check className="d-50" />
                                </div>
                                <div className="font-size-sm text-success">
                                    PDF file accepted!
                                </div>
                            </div>
                        )}
                        {isDragReject && (
                            <div>
                                {/* <div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white">
                                    <X className="d-60" />
                                </div> */}
                                <div className="font-size-sm text-danger">
                                    Only PDF files less than 5MB are allowed!
                                </div>
                            </div>
                        )}
                        {!isDragActive && (
                            <div className="upload_detail upload_detail2 text-center">
                                <img src="/assets/images/upload.svg" alt="Upload" />
                                <h4>Upload Writing Sample</h4>
                                <h5 className='wid_text'>Please upload a writing sample in PDF format with a maximum size of 5MB</h5>
                                <h6  onClick={e => {
                                        e.stopPropagation();
                                        setShowWritingProposal(true);
                                    }}>
                                    <i className="bi bi-info-circle"></i> Document Templates
                                </h6>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showWritingProposal && <WritingSample onClose={() => setShowWritingProposal(false)} />}

            {currentFile && (
                <div className="mt-3">
                    <FileUploadDisplay
                        file={currentFile}
                        onRemove={handleRemoveFile}
                        showDownload={true}
                        showView={true}
                        showRemove={true}
                    />
                </div>
            )}
        </>
    );
};

export default UploadWritingSample;
